import React from 'react';
import { Cart } from '../../icons/Cart';
import { Path } from '../../routes/components/path';
import { MenuLink } from './MobileMenu';
import { useRecentOrders } from '../../state/user/hooks/useRecentOrders';

type Props = {
  onClick: () => void;
};

export const HistoryMenuLink: React.FC<Props> = ({ onClick }) => {
  const { orders, isLoading } = useRecentOrders();

  return (
    <MenuLink
      url={Path.OrderHistory}
      onClick={onClick}
      icon={<Cart />}
      text={`Tilaukset${!isLoading && orders.length > 0 ? ` (${orders.length})` : ''}`}
    />
  );
};
